import { createSelector } from 'reselect';
import { type ExperienceResult, EXPERIENCE_FAILED } from '../../../common/constants';
import type { ExperienceTrackingState } from '../../reducers/persisted/experience-tracking';
import type { State } from '../../reducers/types';
import { getPersisted } from '../common';

export const getExperienceTracking = (state: State): ExperienceTrackingState =>
	getPersisted(state).experienceTracking;

export const getExperienceTrackingInitialFetchStatus = (state: State): ExperienceResult =>
	getExperienceTracking(state).initialDataLoadStatus;

export const getHasLoadedIssueDataFromCache = (state: State): boolean =>
	getExperienceTracking(state).hasLoadedIssueDataFromCache;

const getErrorStatusCode = (state: State): number | undefined =>
	getExperienceTracking(state).errorStatusCode;

export type FailureEventAttributes = {
	[key: string]: string | boolean | number;
};
export const getInitialFetchErrorEventAttributes = createSelector(
	getExperienceTrackingInitialFetchStatus,
	getHasLoadedIssueDataFromCache,
	getErrorStatusCode,
	(
		initialDataLoadStatus,
		hasLoadedIssueDataFromCache,
		errorStatusCode,
	): FailureEventAttributes | undefined => {
		if (initialDataLoadStatus === EXPERIENCE_FAILED) {
			return {
				didFallbackOnIssueCache: hasLoadedIssueDataFromCache,
				errorMessage:
					errorStatusCode !== undefined
						? `Initial fetch failed with status code ${errorStatusCode}`
						: 'Initial fetch failed',
			};
		}
		return undefined;
	},
);
